export default __webpack_public_path__ + "static/media/icon_sass.91714f74.png";